/**
 * @generated SignedSource<<77c1502b8f56f75e057868e3bb553d28>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OwnProfileScreenQuery$variables = Record<PropertyKey, never>;
export type OwnProfileScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OwnProfileView_query">;
};
export type OwnProfileScreenQuery = {
  response: OwnProfileScreenQuery$data;
  variables: OwnProfileScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v1/*:: as any*/),
  (v2/*:: as any*/)
],
v4 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": {
        "equalTo": "PROFILE"
      }
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v5 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "SEQUENCE_ASC"
    ]
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isOther",
    "storageKey": null
  },
  (v1/*:: as any*/),
  (v0/*:: as any*/),
  (v2/*:: as any*/)
],
v7 = [
  (v1/*:: as any*/),
  (v0/*:: as any*/),
  (v2/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OwnProfileScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OwnProfileView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OwnProfileScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isVerified",
                "storageKey": null
              },
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "activities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v3/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "age",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BeliefSystem",
                "kind": "LinkedField",
                "name": "beliefSystem",
                "plural": false,
                "selections": (v3/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "biography",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChildrenPreference",
                "kind": "LinkedField",
                "name": "childrenPreference",
                "plural": false,
                "selections": (v3/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "closestCity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DeetConnection",
                "kind": "LinkedField",
                "name": "deets",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Deet",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v3/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EducationLevel",
                "kind": "LinkedField",
                "name": "educationLevel",
                "plural": false,
                "selections": (v3/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Gender",
                "kind": "LinkedField",
                "name": "gender",
                "plural": false,
                "selections": (v3/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "genderOther",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heightCm",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heightFt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heightIn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "occupation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PoliticalView",
                "kind": "LinkedField",
                "name": "politicalView",
                "plural": false,
                "selections": (v3/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Pronoun",
                "kind": "LinkedField",
                "name": "pronoun",
                "plural": false,
                "selections": (v3/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "school",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VaccinationStatus",
                "kind": "LinkedField",
                "name": "vaccinationStatus",
                "plural": false,
                "selections": (v3/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "distanceInKilometers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "distanceInMiles",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "instagram",
                "storageKey": null
              },
              (v1/*:: as any*/),
              {
                "alias": "profilePhotos",
                "args": (v4/*:: as any*/),
                "concreteType": "PhotoConnection",
                "kind": "LinkedField",
                "name": "photos",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhotoEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Photo",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          (v0/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sequence",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorageObject",
                            "kind": "LinkedField",
                            "name": "storageObject",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "blurhash",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bucket",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "key",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": "photos(filter:{\"type\":{\"equalTo\":\"PROFILE\"}},first:10)"
              },
              {
                "alias": "profilePhotos",
                "args": (v4/*:: as any*/),
                "filters": [
                  "filter"
                ],
                "handle": "connection",
                "key": "useProfilePhotos_profile_profilePhotos",
                "kind": "LinkedHandle",
                "name": "photos"
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Verification",
            "kind": "LinkedField",
            "name": "verification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMetricSystem",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*:: as any*/),
            "concreteType": "UserPromptConnection",
            "kind": "LinkedField",
            "name": "userPrompts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserPrompt",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Prompt",
                    "kind": "LinkedField",
                    "name": "prompt",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "question",
                        "storageKey": null
                      },
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "userPrompts(orderBy:[\"SEQUENCE_ASC\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "GENDER_BY_GENDER_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "GenderCriterionConnection",
            "kind": "LinkedField",
            "name": "genderCriteria",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GenderCriterion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "genderId",
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "genderCriteria(orderBy:[\"GENDER_BY_GENDER_ID__SEQUENCE_ASC\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "UserActivityConnection",
            "kind": "LinkedField",
            "name": "userActivities",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserActivity",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activityId",
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "userActivities(orderBy:[\"ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "DEET_BY_DEET_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "UserDeetConnection",
            "kind": "LinkedField",
            "name": "userDeets",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserDeet",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deetId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "other",
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "userDeets(orderBy:[\"DEET_BY_DEET_ID__SEQUENCE_ASC\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "UserRelationshipTypeConnection",
            "kind": "LinkedField",
            "name": "userRelationshipTypes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserRelationshipType",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relationshipTypeId",
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "userRelationshipTypes(orderBy:[\"RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC\"])"
          },
          (v0/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "DeetConnection",
        "kind": "LinkedField",
        "name": "deets",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Deet",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v6/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "deets(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "ActivityConnection",
        "kind": "LinkedField",
        "name": "activities",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Activity",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v7/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "activities(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "GenderConnection",
        "kind": "LinkedField",
        "name": "genders",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Gender",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v6/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "genders(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "RelationshipTypeConnection",
        "kind": "LinkedField",
        "name": "relationshipTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RelationshipType",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v7/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "relationshipTypes(orderBy:[\"SEQUENCE_ASC\"])"
      }
    ]
  },
  "params": {
    "cacheID": "bd0c534c3e72e0b662df7f5878542de4",
    "id": null,
    "metadata": {},
    "name": "OwnProfileScreenQuery",
    "operationKind": "query",
    "text": "query OwnProfileScreenQuery {\n  ...OwnProfileView_query\n}\n\nfragment ActivitiesMultiSelectInput_query on Query {\n  activities(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment DeetsMultiSelectInput_query on Query {\n  deets(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      isOther\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment GendersMultiSelectInput_query on Query {\n  genders(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      isOther\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment OwnProfileInfo_profile on Profile {\n  activities {\n    nodes {\n      name\n      id\n    }\n  }\n  age\n  beliefSystem {\n    name\n    id\n  }\n  biography\n  childrenPreference {\n    name\n    id\n  }\n  closestCity\n  deets {\n    nodes {\n      name\n      id\n    }\n  }\n  educationLevel {\n    name\n    id\n  }\n  gender {\n    name\n    id\n  }\n  genderOther\n  heightCm\n  heightFt\n  heightIn\n  occupation\n  politicalView {\n    name\n    id\n  }\n  pronoun {\n    name\n    id\n  }\n  school\n  userId\n  vaccinationStatus {\n    name\n    id\n  }\n}\n\nfragment OwnProfileInfo_query on Query {\n  deets(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      isOther\n      name\n      rowId\n      id\n    }\n  }\n  currentUser {\n    isMetricSystem\n    userPrompts(orderBy: [SEQUENCE_ASC]) {\n      nodes {\n        answer\n        prompt {\n          question\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n  ...ActivitiesMultiSelectInput_query\n  ...DeetsMultiSelectInput_query\n  ...GendersMultiSelectInput_query\n  ...RelationshipTypesMultiSelectInput_query\n  ...useGenderCriteria_query\n  ...useUserActivities_query\n  ...useUserDeets_query\n  ...useUserRelationshipTypes_query\n}\n\nfragment OwnProfileView_query on Query {\n  currentUser {\n    profile {\n      isVerified\n      rowId\n      ...OwnProfileInfo_profile\n      ...ProfileCard_profile\n      id\n    }\n    verification {\n      status\n      id\n    }\n    id\n  }\n  ...OwnProfileInfo_query\n  ...ProfileCard_query\n}\n\nfragment ProfileCard_profile on Profile {\n  age\n  closestCity\n  distanceInKilometers\n  distanceInMiles\n  instagram\n  isVerified\n  name\n  rowId\n  userId\n  ...ProfileVerifiedBadge_profile\n  ...useProfilePhotos_profile\n}\n\nfragment ProfileCard_query on Query {\n  currentUser {\n    isMetricSystem\n    rowId\n    id\n  }\n}\n\nfragment ProfileVerifiedBadge_profile on Profile {\n  isVerified\n}\n\nfragment RelationshipTypesMultiSelectInput_query on Query {\n  relationshipTypes(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment useGenderCriteria_query on Query {\n  currentUser {\n    genderCriteria(orderBy: [GENDER_BY_GENDER_ID__SEQUENCE_ASC]) {\n      nodes {\n        genderId\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment useProfilePhotos_profile on Profile {\n  profilePhotos: photos(first: 10, filter: {type: {equalTo: PROFILE}}) {\n    edges {\n      cursor\n      node {\n        description\n        rowId\n        sequence\n        storageObject {\n          blurhash\n          bucket\n          key\n        }\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment useUserActivities_query on Query {\n  currentUser {\n    userActivities(orderBy: [ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC]) {\n      nodes {\n        activityId\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment useUserDeets_query on Query {\n  currentUser {\n    userDeets(orderBy: [DEET_BY_DEET_ID__SEQUENCE_ASC]) {\n      nodes {\n        deetId\n        other\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment useUserRelationshipTypes_query on Query {\n  currentUser {\n    userRelationshipTypes(orderBy: [RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC]) {\n      nodes {\n        relationshipTypeId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c2aea17cefdf4bb91592780da72b133";

export default node;
